export let Enterprise = {
    path: 'enterprise',
    name: 'enterprise',
    meta: {
        roleCode: '004',
    },
    component: () =>
        import(
            /* webpackChunkName: "enterprise-page" */ '@/views/back-stage/enterprise/enterprise-page.vue'
        ),
    children: [
        {
            path: 'enterprise-base',
            name: 'enterprise-base',
            component: () =>
                import(
                    /* webpackChunkName: "enterprise-base" */ '@/views/back-stage/enterprise/enterprise-base.vue'
                ),
        },
        {
            path: 'enterprise-logo',
            name: 'enterprise-logo',
            component: () =>
                import(
                    /* webpackChunkName: "enterprise-logo" */ '@/views/back-stage/enterprise/enterprise-logo.vue'
                ),
        },
        {
            path: 'enterprise-org',
            name: 'enterprise-org',
            component: () =>
                import(
                    /* webpackChunkName: "enterprise-org" */ '@/views/back-stage/enterprise/enterprise-org.vue'
                ),
        },
        {
            path: 'enterprise-set',
            name: 'enterprise-set',
            component: () =>
                import(
                    /* webpackChunkName: "enterprise-set" */ '@/views/back-stage/enterprise/enterprise-set.vue'
                ),
        },
        {
            path: '*',
            redirect: 'enterprise-base',
        },
    ],
};
